import { Component, inject, NgZone, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, map } from 'rxjs';

import { ArmyBuilderConfig } from '../../../global/config';
import { InputAlert } from '../../../global/input-alert/input-alert';
import { snapshot } from '../../../global/utils';
import { ForceService } from '../../force.service';
import { ForceUtils } from '../../force.utils';
import { Force, Faction } from '../../models';
import { DataLibrary } from '../../../global/data-library';
import { GAME_ID } from '../../..';

@Component({
    standalone: false,
    selector: 'abs-force-type',
    template: `
        <abs-page-layout [pageTitle]="'FORCES.HEADERS.SELECT_FORCE_TYPE' | translate">
            <abs-list
                [items]="factions$ | async"
                groupBy="faction"
                (itemSelect)="itemSelected($event.item)"
                [template]="forceTypeRow"
                [noItemsTextKey]="'FORCES.ERRORS.NO_FACTION_DATA'"
            ></abs-list>
            <ng-template let-item="item" #forceTypeRow>
                <div class="itemName">
                    {{ item.name | language | async }}
                </div>
            </ng-template>
        </abs-page-layout>
    `
})
export class ForceTypePage {
    gameId: string = inject(GAME_ID);
    factions$ = this.dataLibrary.factions$.pipe(map((factions) => [...factions].sort((a, b) => a.name.en.localeCompare(b.name.en))));

    constructor(
        public forceService: ForceService,
        public dataLibrary: DataLibrary,
        public route: ActivatedRoute,
        public router: Router,
        private inputAlert: InputAlert,
        public config: ArmyBuilderConfig,
        protected zone: NgZone,
        public translateService: TranslateService,
        public forceUtils: ForceUtils
    ) {}

    getForceFromForceType(forceType: Faction): Omit<Force, 'id'> {
        const defaultForce = this.forceUtils.getDefaultForce(forceType);
        return {
            ...defaultForce
        };
    }

    itemSelected(forceType: Faction) {
        const f: Omit<Force, 'id'> = this.getForceFromForceType(forceType);

        const title = this.translateService.instant('FORCES.DIALOGS.NEW_FORCE.TITLE');
        const message = this.translateService.instant('FORCES.DIALOGS.NEW_FORCE.MESSAGE');
        const defaultForceName = this.translateService.instant('FORCES.DIALOGS.NEW_FORCE.DEFAULT_FORCE_NAME', forceType);

        console.log('!!!!!');
        this.inputAlert.show(title, message, defaultForceName, 'text', true).then((name) => {
            if (!name) {
                return;
            }
            f.name = name;
            this.forceService.add(f as Force).subscribe((newForce) => {
                setTimeout(() => {
                    this.zone.run(() => this.router.navigate(['..', newForce.id], { relativeTo: this.route, replaceUrl: true }));
                }, 100);
            });
        });
    }
}
